import { evaluate } from 'mathjs';

function tehostaVesivirta(teho) {
  const scope = {
    Q: teho,
    c: 4.182,
    dt: 45,
  }
  return evaluate('(Q / (c * dt)) * 3.6', scope);
}


export default {
  liittymismaksu(rakennustyyppi, tehontarve) {
    const vesivirta = tehostaVesivirta(tehontarve);
    const categories = [
      {
        min: 0,
        max: 1.4,
        a: 3.5,
        b: 530.89,
        c: 1042.09,
      },
      {
        min: 1.4,
        max: 4,
        a: 3.5,
        b: 336.38,
        c: 1177.32,
      },
      {
        min: 4,
        max: 15,
        a: 3.5,
        b: 2018.26,
        c: 756.85,
      },
    ];

    const kategoria = categories.find(c => vesivirta >= c.min && vesivirta < c.max);
    kategoria.vesivirta = vesivirta;
    return evaluate('a * (b + c * vesivirta)', kategoria);
  },
  tehomaksu(rakennustyyppi, tehontarve) {
    const vesivirta = tehostaVesivirta(tehontarve);
    const kategoriat = [
      {
        min: 0,
        max: 5,
        a: 5.89,
        b: 0,
        c: 336.38,
      },
      {
        min: 5,
        max: 999999999,
        a: 5.89,
        b: 840.94,
        c: 168.19
      },
    ];

    const kategoria = kategoriat.find(c => vesivirta >= c.min && vesivirta < c.max);
    kategoria.vesivirta = vesivirta;
    return evaluate('a * (b + c * vesivirta)', kategoria);
  },
  energiamaksu(/*rakennustyyppi*/) {
    return 65.91;
  },
}
